// react
import React, { Fragment, useState, useEffect } from "react";
// store
import { companyService } from "../../../../store/services/ServiceCompany";
import { LOADING_TIME } from "../../../../store/config";
import { routes } from "../../../../store/routes";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import CoachNetworkTable from "./CoachNetworkTable";
import ButtonAdd from "../../../../components/buttons/ButtonAdd";
import Loading from "../../../../components/others/Loading";

// component
function CoachNetwork() {
    // state
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const result = await companyService.getCoachNetwork();
            setData(result);

            setTimeout(function () {
                setIsLoading(false);
            }, LOADING_TIME);
        };

        fetchData();
    }, []);

    // template
    return (
        <Fragment>
            <HeaderTitle title="Kouč - sieť poskytovateľov" />
            <section>
                {isLoading ? (
                    <Loading />
                ) : (
                    <>
                        <div style={{ marginBottom: "1rem", padding: "0rem 1rem", background: "#f8f9fa", border: "1px solid #e0e0e0", borderRadius: "8px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "1rem", overflow: "hidden" }}>
                            <span style={{ fontSize: "0.9rem", color: "#555", fontWeight: 500 }}>
                                Celkovo v sieti: <strong style={{ color: "#1a1a1a", fontSize: "1rem" }}>{data.length}</strong> {data.length === 1 ? "poskytovateľ" : data.length < 5 ? "poskytovatelia" : "poskytovateľov"}
                            </span>
                            <div>
                                <ButtonAdd
                                    link={routes.COACH_REGISTRATION}
                                    text="Zaregistrovať poskytovateľa"
                                />
                            </div>
                        </div>
                        <CoachNetworkTable
                            providers={data}
                            isLoading={isLoading}
                        />
                    </>
                )}
            </section>
        </Fragment>
    );
}

export default CoachNetwork;
